/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.31",
    versionName: "0.2.0-nightly.2025.10.31",
    versionChannel: "nightly",
    buildDate: "2025-10-31T00:09:32.798Z",
    commitHash: "5e1cc9343367d9cb6eb82326cff066bace3a3dba",
};
